export function closeStrip() {
  let stripcode = $('.header__strip').attr('data-code')
  let strip = localStorage.hasOwnProperty("latino_strip_"+stripcode) ? JSON.parse(localStorage.getItem("latino_strip_"+stripcode)) : 0;
  if(strip) { $('body').removeClass('has-strip') }
  $('.header__strip a:last-child').click(function(e){
    e.preventDefault();
    $('body').removeClass('has-strip')
    localStorage.setItem("latino_strip_"+stripcode, 1);
  })
}

export function stickyHeader() {
  const selector = document.querySelector('.hero .hero__observer, .swiper__observer')
  if(selector) {
    var observer = new IntersectionObserver(function(entries) {
      if(entries[0].intersectionRatio === 0) {
        $('body').addClass('sticky-header');
        setTimeout(function(){ window.dispatchEvent(new Event('resize')) }, 600);
      } else if(entries[0].intersectionRatio === 1) {
        $('body').removeClass('sticky-header');
        setTimeout(function(){ window.dispatchEvent(new Event('resize')) }, 600);
      }
    }, { threshold: [0,1] });
    observer.observe(selector);
  }
}

export function submenuMobile() {
  $('.menu-item-has-children').click(function(e){
    if (e.target !== this) return;
    $(this).toggleClass('open');
    $(this).find('ul').slideToggle(200);
  })
}
